export class WorkerCredentialsStatusRequest {
    workerId: number;
    active: boolean;
}